import { AxiosResponse } from "axios";

export const handleRodaStatusChange = async (
  rodaId: number,
  action: (id: number) => Promise<AxiosResponse>,
  getRodas: () => Promise<void>,
  closeModal: () => void
) => {
  await action(rodaId);
  await getRodas();
  closeModal();
};
